/*
Property card
*/

import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faDoorOpen,
  faBath,
  faSwimmingPool,
  faPercent,
  faArrowsAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faGem } from "@fortawesome/free-regular-svg-icons";

const PropertyCard = ({
  title,
  img,
  price,
  to,
  occupancy,
  area_sqm,
  bedrooms,
  bathrooms,
  pool,
  diamondDeal,
  has_discounts,
}) => {
  const poolDesc =
    pool && pool.length && pool.width ? `${pool.length}x${pool.width}` : null;
  let pricePill;
  let cardBottom;
  if (bedrooms != null && bathrooms !== null) {
    pricePill = (
      <div className="card-img-overlay-bottom z-index-20">
        <div className="media text-white text-sm align-items-center justify-content-end">
          <div className="">
            <div
              className="text-white p-1 rounded-sm shadow"
              style={{ backgroundColor: "rgba(204, 102, 102, 1)" }}
            >
              <div>
                <span className="h4">Alk. €{price}</span>&nbsp;/vko
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    cardBottom = (
      <>
        <div className="d-flex card-subtitle" style={{ alignItems: "stretch" }}>
          <ul
            className="list-unstyled list-inline text-muted text-sm d-flex flex-1-1"
            style={{ justifyContent: "space-between" }}
          >
            <li className="list-inline-item px-0">
              <FontAwesomeIcon icon={faUsers} fixedWidth className="mr-2" />
              {occupancy}
            </li>
            <li className="list-inline-item px-0">
              <FontAwesomeIcon icon={faDoorOpen} fixedWidth className="mr-1" />
              {bedrooms}
            </li>
            <li className="list-inline-item px-0">
              <FontAwesomeIcon icon={faArrowsAlt} fixedWidth className="mr-1" />
              {area_sqm} m<sup>2</sup>
            </li>
            <li className="list-inline-item px-0">
              <FontAwesomeIcon icon={faBath} fixedWidth className="mr-1" />
              {bathrooms}
            </li>

            <li className="list-inline-item px-0">
              {poolDesc ? (
                <>
                  <FontAwesomeIcon
                    icon={faSwimmingPool}
                    fixedWidth
                    className="mr-1"
                  />
                  {poolDesc}
                </>
              ) : null}
            </li>
          </ul>
        </div>
      </>
    );
  } else {
    cardBottom = (
      <>
        <p className="card-text text-muted">
          <span className="h4 text-primary">€{price}</span>&nbsp;/vko
        </p>
      </>
    );
  }

  let cardTop;
  if (diamondDeal) {
    cardTop = (
      <div className="card-img-overlay-top text-right">
        <div className="card-fav-icon position-relative">
          <FontAwesomeIcon
            icon={faGem}
            size="lg"
            className="svg-icon text-white"
          />
        </div>
      </div>
    );
  } else if (has_discounts) {
    cardTop = (
      <div className="card-img-overlay-top text-right">
        <div className="card-fav-icon position-relative">
          <FontAwesomeIcon
            icon={faPercent}
            // size="lg"
            className="svg-icon text-white"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="card h-100 border-0 shadow">
      <div className="card-img-top overflow-hidden gradient-overlay">
        {img ? (
          <Img
            fluid={img.childImageSharp.fluid}
            alt={title}
            className="img-fluid"
            // 0.15rem 0.15rem 0.7rem 0 rgba(0, 0, 0, 0.075) !important
          />
        ) : null}
        <Link to={to} className="tile-link"></Link>
        {pricePill}
        {cardTop}
      </div>
      <div className="card-body d-flex align-items-center">
        <div className="w-100">
          <h6
            className="card-title"
            style={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            <Link to={to} className="text-decoration-none text-dark">
              {title}
            </Link>
          </h6>
          {cardBottom}
        </div>
      </div>
    </div>
  );
};
export default PropertyCard;
